import { configureStore } from "@reduxjs/toolkit";

import campaignsSlice from "./campaigns-slice";
import donorsSlice from "./donors-slice";
import organizationsSlice from "./organizations-slice";
import paymentsSlice from './payments-slice'
import solicitorsSlice from './solicitors-slice.js'
import paymentTypesSlice from './paymentTypes-slice'
import donorRelationsSlice from './donorRelations-slice'
import uiSlice from './ui-slice'
import tendersSlice from './tenders-slice'
import accountsSlice from './accounts-slice'
import filtersSlice from "./filters-slice";
import authSlice, { setStoreRef } from "./auth-slice";
import shulsSlice from "./shuls-slice";
import pledgesSlice from "./pledges-slice";
import settingsSlice from "./settings-slice";
import statementsSlice from "./statements-slice";
import studentsSlice from "./students-slice";
import hubSlice from "./hub-slice.js";
import locationsSlice from "./locations-slice.js";
import remindersSlice from "./reminders-slice.js";
import parentsSlice from "./parents-slice.js";
import whatsnewSlice from "./whatsnew-slice";
import schoolSlice from "./school-slice";

// Reducer map, named so tests can build their own isolated store from the same source of
// truth instead of duplicating this list. Runtime behavior is unchanged.
export const rootReducer = {
        ui: uiSlice.reducer,
        payments: paymentsSlice.reducer,
        campaigns: campaignsSlice.reducer,
        organizations: organizationsSlice.reducer,
        locations: locationsSlice.reducer,
        donors: donorsSlice.reducer,
        pledges: pledgesSlice.reducer,
        solicitors: solicitorsSlice.reducer,
        paymentTypes: paymentTypesSlice.reducer,
        donorRelations: donorRelationsSlice.reducer,
        tenders: tendersSlice.reducer,
        accounts: accountsSlice.reducer,
        filters: filtersSlice.reducer,
        auth: authSlice.reducer,
        shuls: shulsSlice.reducer,
        settings: settingsSlice.reducer,
        statements: statementsSlice.reducer,
        students: studentsSlice.reducer,
        hub: hubSlice.reducer,
        reminders: remindersSlice.reducer,
        parents: parentsSlice.reducer,
        whatsnew: whatsnewSlice.reducer,
        school: schoolSlice.reducer
        //when you add a slice make sure to reset the state in useResetState hook
};

/**
 * Build a brand new store. Tests use this so each test starts from a clean state and
 * cannot leak into the next one. The app itself uses the single `store` below.
 */
export const createAppStore = (preloadedState) =>
    configureStore({ reducer: rootReducer, preloadedState });

const store = createAppStore();

// Set store reference for auth slice logout timer.
// Only the real app store gets this — test stores must not hijack the logout timer.
setStoreRef(store);

export default store;